<template>
    <th @click="sortByColumn()" style="cursor: pointer" :class="cssClass">
        <slot></slot>

        <i v-if="this.sort !== column" class="fa fa-sort" style="color: grey"></i>
        <i v-if="this.sort === column && this.direction === 'asc'"  class="fa fa-sort-up"></i>
        <i v-if="this.sort === column && this.direction === 'desc'"  class="fa fa-sort-down"></i>
    </th>
</template>

<script>
    export default {
        props: [
            'column',
            'sort',
            'direction',
            'cssClass',
        ],
        data() {
            return {
            };
        },
        methods: {
            sortByColumn() {
                if (this.sort === this.column) {
                    // switch asc/desc
                    let dir = this.direction === 'asc' ? 'desc' : 'asc';
                    this.$emit('sorted', {col: this.column, dir: dir});
                }
                else {
                    // set to col & asc
                    this.$emit('sorted', {col: this.column, dir: 'asc'});
                }
            }
        }
    }
</script>
